export function dailyHistoryStage(batch) {
  if(batch.stopped)return '已停止'
  if(batch.target_count>0 && batch.generated_count===batch.target_count)return '图片已生成'
  if(batch.preparation_failed_count>0)return '内容准备待恢复'
  if(batch.preparing_count>0)return '正在准备文案'
  if(batch.waiting_for_phone_count>0)return '等待手机同步'
  if(batch.received_count>batch.generated_count)return '手机生成中'
  return '进度待核对'
}
